import React from "react";
import SelectBox, { SelectBoxProps } from "./SelectBox";
import { useCountriesData } from "../../services/public.services";

const CountrySelectInput: React.FC<Omit<SelectBoxProps, "options">> = ({ ...selectBoxProps }) => {
  const { data, isLoading, error } = useCountriesData();

  const countryOptions = Array.isArray(data?.Countries)
    ? data.Countries.map((country: any) => ({
        label: country.CountryName,
        value: country.CountryName,
      }))
    : [];
  return <SelectBox options={countryOptions} loading={isLoading} errorText={error ? "Failed to load counties options" : ""} {...selectBoxProps} showSearch />;
};

export default CountrySelectInput;
